<i18n src="@/lang/actions.json" />
<i18n src="@/lang/messages.json" />
<i18n>
  {
  "en": {
  "requestData":{
  "client_secret": "Секретный ключ",
  "client_id": "ID интеграции",
  "code":"Код авторизации",
  "redirect_uri":"Ссылка для перенаправления"
  },
  "more": "More ...",
  "check":"Check"
  },
  "ua": {
  "requestData":{
  "client_secret": "Секретный ключ",
  "client_id": "ID интеграции",
  "code":"Код авторизации",
  "redirect_uri":"Ссылка для перенаправления"
  },
  "more": "Більше ...",
  "check":"Перевірити"
  },
  "ru": {
  "requestData":{
  "client_secret": "Секретный ключ",
  "client_id": "ID интеграции",
  "code":"Код авторизации",
  "redirect_uri":"Ссылка для перенаправления"
  },
  "more": "Больше ...",
  "check":"Проверить"
  }
  }
</i18n>
<template>
  <el-col>
    <section-divider icon="el-icon-lightning" text="OAuth" />
    <el-row>
      <el-col>
        <el-collapse :value="Number(!hasOAuth)">
          <el-collapse-item :name="1">
            <template slot="title">
              <div style="display:inherit; justify-content: flex-start">
                <div>
                  <i :class="checkClass" />
                  Integration
                </div>
                <el-button
                  v-if="integrationCheckStatus === undefined && hasOAuth"
                  type="text"
                  v-text="$t('check')"
                  style="margin-left: 30px"
                  :loading="integrationCheckStatus === 'loading'"
                  @click.stop.prevent="handleCheckOAuth"
                />
                <span
                  v-else-if="
                    integrationCheckStatus instanceof Object &&
                      integrationCheckStatus.error
                  "
                  class="oauth-status-error"
                  v-text="integrationCheckStatus.error"
                />
                <span
                  v-else-if="
                    integrationCheckStatus instanceof Object &&
                      integrationCheckStatus.service
                  "
                  class="oauth-status-ok"
                  v-text="'Ok'"
                />
              </div>
            </template>
            <el-row>
              <template v-for="(label, key, index) in $t('requestData')">
                <div class="element" :key="key">
                  <template
                    v-if="
                      index === Object.keys($t('requestData')).length - 1 &&
                        !showMore
                    "
                  >
                    <span
                      class="details"
                      v-text="$t('more')"
                      @click="showMore = !showMore"
                    />
                  </template>
                  <template
                    v-if="
                      index !== Object.keys($t('requestData')).length - 1 ||
                        showMore
                    "
                  >
                    <div class="label" v-text="label" />
                    <el-input v-model="requestData[key]" />
                  </template>
                </div>
              </template>
            </el-row>
            <el-row type="flex" justify="end" style="margin-top: 20px">
              <el-button
                :disabled="!showBtn"
                type="default"
                size="small"
                @click="handleMakeIntegratin"
              >
                {{ $t("actions.send") }}
              </el-button>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import SectionDivider from "../SectionDivider";

export default {
  name: "oauth-section",
  components: { SectionDivider },
  props: {
    service: Object
  },
  created() {
    window.t = this;
  },
  data() {
    return {
      requestData: {
        domain: this.service.amoDomain,
        client_id: this.service._embedded.sharedIntegrations
          ? this.service._embedded.sharedIntegrations.integration_uuid
          : "",
        client_secret: this.service._embedded.sharedIntegrations
          ? this.service._embedded.sharedIntegrations.secret
          : "",
        grant_type: "authorization_code",
        code: undefined,
        redirect_uri: this.service._embedded.sharedIntegrations
          ? this.service._embedded.sharedIntegrations._links.redirect_uri.href
          : this.service._embedded.sharedWidgets
          ? this.service._embedded.sharedWidgets.uri
          : ""
      },
      showMore: true,
      integrationCheckStatus: undefined
    };
  },
  methods: {
    async handleMakeIntegratin() {
      let res = await this.service.makeIntegrationFromAccessCode(
        this.requestData
      );
      this.requestData.code = undefined;
      this.$notify.success({
        message: this.$t("messages.added")
      });
    },
    handleCheckOAuth() {
      this.integrationCheckStatus = "loading";
      this.service
        .checkOauth()
        .then(res => {
          this.integrationCheckStatus = res;
          if (res.error) {
            this.$notify.error({
              message: res.error
            });
            return;
          }
          this.$notify.success({
            message: this.$t("messages.checked")
          });
        })
        .catch(() => {
          this.$notify.error({
            message: this.$t("messages.something_went_wrong")
          });
        });
    }
  },
  computed: {
    showBtn() {
      let skipList = ["redirect_uri"];
      return Object.keys(this.requestData).reduce((r, k) => {
        return r && (skipList.includes(k) || Boolean(this.requestData[k]));
      }, true);
    },
    hasOAuth() {
      try {
        return (
          this.service.sharedIntegrations_uuid &&
          this.service._embedded.sharedIntegrations.OAuth
        );
      } catch (e) {
        return false;
      }
    },
    checkClass() {
      let v = [
        "header-icon",
        {
          "el-icon-close": !this.hasOAuth,
          "el-icon-check": this.hasOAuth
        }
      ];
      if (
        this.integrationCheckStatus &&
        this.integrationCheckStatus !== "loading"
      ) {
        this.integrationCheckStatus.error
          ? v.push("oauth-status-error")
          : v.push("oauth-status-ok");
      }
      return v;
    }
  }
};
</script>

<style scoped lang="stylus">
.header-icon
  margin-right 5px
  color #b2b2ba

.element
  &:not(:first-child)
    margin-top 10px

  .label
    background-color #666
    -webkit-background-clip text
    background-clip text
    color transparent
    text-shadow rgba(255, 255, 255, 0.5) 0px 3px 3px

.details
  color #409eff
  cursor pointer

.oauth-status
  &-ok
    color: green
  &-error
    color red
span.oauth-status-error
  padding-left 30px
  font-weight normal
  font-size 90%
span.oauth-status-ok
  padding-left 30px
  font-weight normal
  font-size 90%
</style>
